<template>
  <!-- <div id="app" v-if="showPage">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"/>
  </div>
  <div id="app" v-else-if="showJumpPage">
    <router-view/>
  </div> -->
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <!-- 底部tabbar导航 -->
    <!-- <template v-if="$route.meta.tabbar">
      <tabbar v-model="activeIndex" isUpdateCountInfo :tabbarList="tabbarList"></tabbar>
    </template> -->
  </div>
</template>

<script>
import { api } from '@/api'
import { mapGetters, mapActions } from 'vuex'
import { getCookie, setCookie } from '@/utils/common'
// import Tabbar from '@/components/tabbar'

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  // components: {
  //   Tabbar
  // },
  data () {
    return {
      showPage: false,
      showJumpPage: true,
      isRouterAlive: true,
      // 以下用来记录监听到的旧数据，防止死循环（兼容ie）
      token: '',
      userInfo: '',
      loadingToast: null,
      wxLoginLoadingToast: null, // 微信登录加载动画
      // tabbarList: [
      //   {
      //     title: '竞价',
      //     normal: require('@/assets/images/tabbar/auction-line.svg'),
      //     active: require('@/assets/images/tabbar/auction-line-active.svg'),
      //     router: '/biddingNotice'
      //   },
      //   {
      //     title: '公告',
      //     normal: require('@/assets/images/tabbar/notice-line.svg'),
      //     active: require('@/assets/images/tabbar/notice-line-active.svg'),
      //     router: '/biddingWinNotice'
      //   },
      //   {
      //     title: '我的',
      //     normal: require('@/assets/images/tabbar/my-line.svg'),
      //     active: require('@/assets/images/tabbar/my-line_active.svg'),
      //     router: '/setInfo'
      //   }
      // ],
      //activeIndex: 0
    }
  },
  computed: {
    ...mapGetters(['region', 'channel', 'customer'])
  },
  watch: {
    '$route': 'routeLogin',
    // activeIndex: {
    //   handler(val, oldName) {
    //     console.log(156651, val)
    //     sessionStorage.setItem('activeIndex', val)
    //   }
    // } 
  },
  created () {
    // console.log('开发环境', process.env);
    // console.log('getBrowserType', navigator.userAgent)
    // 判断是否微信浏览器
    // if(navigator.userAgent.indexOf('MicroMessenge') !== -1) {
    //   sessionStorage.setItem('wechat', true)
    // }else {
    //   sessionStorage.setItem('wechat', false)
    // }
    // 记录进入APP时的url
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = location.href.split('#')[0]
      // 如果访问路由为/jumpPage，删除本地缓存
      if (window.entryUrl.indexOf('/jumpPage') > -1) {
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('br-custom-key')
        sessionStorage.removeItem('defaultCustomer')
        sessionStorage.removeItem('isDriver')
        sessionStorage.removeItem('groupBuyingCache')
        sessionStorage.removeItem('flashSaleCache')

        // 设置包含“KERPSESSIONIDdev”关键字的cookie的key
        if (document.cookie.length > 0) {
          const cName = 'KERPSESSIONIDdev'
          let cStart = document.cookie.indexOf(cName)
          while (cStart !== -1) {
            let cEnd = document.cookie.indexOf('=', cStart)
            if (getCookie(document.cookie.substring(cStart, cEnd))) {
              setCookie(document.cookie.substring(cStart, cEnd), '', -1)
            }
            cStart = document.cookie.indexOf(cName)
          }
        }
      }
    }

    if (location.href.indexOf('/jumpPage') > -1) {
      this.showJumpPage = true
    } else {
      // this.loadingToast = this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   loadingType: 'spinner',
      //   message: '加载中...'
      // })
      //this.init()
    }
    // this.listenSessionStorage()
    // let activeIndex = sessionStorage.getItem('activeIndex')
    // console.log('app52151', activeIndex)
    // console.log('this.$route', this.$router.query)
    // console.log('this.$route.query0',this.$router.history._startLocation)
    // console.log('this.$route.query1',this.$router.history.current)
    // console.log('this.$route.query2',this.$router.history.current.name)
    // const tabindex = this.tabbarList.findIndex((item) => item.router === this.$router.history._startLocation)
    // console.log('this.$route.query3', this.tabbarList.findIndex((item) => item.router === this.$router.history._startLocation))
    // const current = this.$router.history._startLocation
    // console.log('Number(activeIndex)', Number(activeIndex))
    // if(!this.$router.history._startLocation || this.$router.history._startLocation === '/') {
    //   console.log('null11_startLocation')
    //   this.activeIndex = 0
    //   sessionStorage.setItem('activeIndex', 0)
    // }else if(Number(activeIndex) && tabindex > -1) {
    //   this.activeIndex = Number(activeIndex)
    // }else if(Number(activeIndex) === 0 && activeIndex) {
    //   console.log('null11')
    //   this.activeIndex = 0
    //   sessionStorage.setItem('activeIndex', 0)
    // }else if(tabindex === -1 && activeIndex) {
    //   console.log('tabindex === -1 && activeIndex', activeIndex)
    //   this.activeIndex = Number(activeIndex)
    // }else {
    //   console.log('null')
    //   this.activeIndex = 0
    //   this.$router.push({name: 'biddingNotice'})
    //   sessionStorage.setItem('activeIndex', 0)
    // }
    // console.log('this.activeIndex', this.activeIndex)
  },
  mounted () {
    console.log('appmounted')
    // this.routeLogin()
    this.$nextTick(() => {
      setTimeout(() => {
        this.$toast.clear()
      }, 2000)
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    ...mapActions(['setChannel', 'setRegion', 'setCurrentRegion', 'setAllRegion', 'setAllChannel', 'setCustomer', 'setJustLoggedIn']),
    // 路由登录
    routeLogin () {
      if (this.$route.query.token) {
        try {
          // 如果地址中存在token，删除本地缓存
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('br-custom-key')
          sessionStorage.removeItem('defaultCustomer')
          sessionStorage.removeItem('isDriver')
          sessionStorage.removeItem('groupBuyingCache')
          sessionStorage.removeItem('flashSaleCache')
        } finally {
          //this.afterWXLogin(decodeURIComponent(this.$route.query.token))
          this.$route.query.sessionId && sessionStorage.setItem('sessionId', this.$route.query.sessionId)
        }
      } else if (this.$route.query.sessionId) { // 微信登录失败，使用填写信息登录并绑定
        if (this.$route.query.redirectParam && +JSON.parse(this.$route.query.redirectParam).redirectNow === 1 && +JSON.parse(this.$route.query.redirectParam).customerType === 3) {
          this.$router.replace({ name: 'Index', params: { redirectPage: this.$route.query.redirect, redirectPageParam: JSON.stringify({ doRedirect: 1, ...JSON.parse(this.$route.query.redirectParam) }) } })
          return
        }
        if (this.$route.path !== '/login' && this.$route.path !== '/loginRandom') {
          this.$toast('请先登录，将自动绑定微信')
          this.$router.push({ name: 'login', query: this.$route.query })
        }
      } else if (this.$route.params.redirectPage) {
        this.$router.push({ name: this.$route.params.redirectPage, query: JSON.parse(this.$route.params.redirectPageParam) })
      }
    },
    // 监听sessionStorage变化
    listenSessionStorage () {
      const orignalSetItem = sessionStorage.setItem
      sessionStorage.setItem = function (key, newValue) {
        let setItemEvent = new Event('setItemEvent')
        setItemEvent.key = key
        setItemEvent.newValue = newValue
        window.dispatchEvent(setItemEvent)
        orignalSetItem.apply(this, arguments)
      }
    },
    // // 微信登录成功后
    // afterWXLogin (token) {
    //   this.wxLoginLoadingToast = this.$toast.loading({
    //     duration: 0, // 持续展示 toast
    //     overlay: true, // 显示背景蒙层
    //     message: '正在登录...'
    //   })

    //   this.setJustLoggedIn(true) // 设置刚登录状态
    //   sessionStorage.setItem('token', token)
    //   setCookie('user_token', token, 7)
    //   // 设置包含“KERPSESSIONIDdev”关键字的cookie的key
    //   if (document.cookie.length > 0) {
    //     const cName = 'KERPSESSIONIDdev'
    //     let cStart = document.cookie.indexOf(cName)
    //     while (cStart !== -1) {
    //       let cEnd = document.cookie.indexOf('=', cStart)
    //       setCookie(document.cookie.substring(cStart, cEnd), token, 1)
    //       cStart = document.cookie.indexOf(cName, cStart + cName.length + 1)
    //     }
    //   }

    //   api.userInfo().then(res => { // 查询用户信息（包括是否为司机）
    //     if (res.success) {
    //       sessionStorage.setItem('br-custom-key', res.data.phone)
    //       sessionStorage.setItem('userInfo', JSON.stringify(res.data))
    //       res.data.userId && sessionStorage.setItem('userId', res.data.userId)
    //       sessionStorage.setItem('isDriver', res.data.isDriver)
    //       // 判断是否为司机
    //       if (res.data.isDriver === '1') { // 如果是司机
    //         this.wxLoginLoadingToast && this.wxLoginLoadingToast.clear()
    //         this.$router.replace({ path: '/order', query: { orderType: 0, index: 0, businessIndex: 0, biztypeId: '' } })
    //         // this._queryCustomerList() // 查询当前用户的所有客户
    //       } else { // 如果不是司机
    //         this.addMemberIntegral() // 增加会员积分

    //         // 查询当前用户的客户列表及默认客户（列表第一个）
    //         // this._queryCustomerList().then(() => {
    //         //   if (getCookie('selectedRegion')) {
    //         //     api.customerAuthQuery({ customerId: this.customer && this.customer.current && this.customer.current.customerId }).then(res => {
    //         //       if (res.success && res.status !== 'noData') {
    //         //         this.setAllChannel(res.data.list.slice(0, res.data.list.length)) // 保存所有渠道/销售部信息

    //         //         this.setChannel({ data: res.data.list })

    //         //         var validRegion = this.region.data ? this.region.data.filter(item => {
    //         //           let obj
    //         //           this.channel.list.forEach(i => {
    //         //             if (item.name.indexOf(i.channelAreaName.split('_')[0]) > -1) {
    //         //               obj = item
    //         //             }
    //         //           })
    //         //           return obj
    //         //         }) : []

    //         //         var current = JSON.parse(getCookie('selectedRegion'))
    //         //         current = validRegion.find(v => current.number === v.number) ? current : validRegion[0]
    //         //         // 根据渠道筛选地区
    //         //         this.setRegion({
    //         //           data: {
    //         //             current,
    //         //             data: validRegion
    //         //           }
    //         //         })

    //         //         // let areaName = this.region && this.region.current && this.region.current.name
    //         //         // let list = this.channel.list.filter(v => {
    //         //         //   return areaName.indexOf(v.channelAreaName.split('_')[0]) > -1
    //         //         // })
    //         //         // this.setChannel({ data: list.length ? list : this.channel.list })
    //         //       } else {
    //         //         this.setChannel({ data: [] })
    //         //       }

    //         //       this.wxLoginLoadingToast && this.wxLoginLoadingToast.clear()
    //         //       if (this.$route.query.redirect) {
    //         //         this.$router.replace({ name: 'Index', params: { redirectPage: this.$route.query.redirect, redirectPageParam: this.$route.query.redirectParam || JSON.stringify({}) } })
    //         //       } else {
    //         //         this.$router.replace({ name: 'Index', params: { needUpdate: true } })
    //         //       }
    //         //     })
    //         //   } else {
    //         //     this.wxLoginLoadingToast && this.wxLoginLoadingToast.clear()
    //         //     if (this.$route.query.redirect) {
    //         //       this.$router.replace({ name: 'Index', params: { redirectPage: this.$route.query.redirect, redirectPageParam: this.$route.query.redirectParam || JSON.stringify({}) } })
    //         //     } else {
    //         //       this.$router.replace({ name: 'Index', params: { needUpdate: true } })
    //         //     }
    //         //   }
    //         // })
    //       }
    //     } else {
    //       this.$toast.fail('登录失败，请重新登录')
    //       res.message && this.$toast({ position: 'bottom', message: res.message.replace('调用移动分销接口失败：', '') })
    //       this.wxLoginLoadingToast && this.wxLoginLoadingToast.clear()
    //       sessionStorage.setItem('userInfo', JSON.stringify({}))
    //       // 登出
    //       api.logout().then(res => {
    //         this.setJustLoggedIn(false) // 设置刚登录状态
    //         sessionStorage.removeItem('token')
    //         sessionStorage.removeItem('br-custom-key')
    //         sessionStorage.removeItem('defaultCustomer')
    //         sessionStorage.removeItem('isDriver')
    //         sessionStorage.removeItem('groupBuyingCache')
    //         sessionStorage.removeItem('flashSaleCache')
    //         this.$router.push({ name: 'login' })
    //       })
    //     }
    //   })
    // },
    // async init () {
    //   let result = await this._getImageFullUrl()
    //   if (result) {
    //     this._getKeys()
    //     this._queryProvince()
    //   }
    // },
    // // 获取全站图片域名，存入sessionStorage
    // _getImageFullUrl () {
    //   // return new Promise(resolve => {
    //   //   api.getImageFullUrl().then(res => {
    //   //     if (res.success) {
    //   //       let url = res.data.url
    //   //       sessionStorage.setItem('allImgDomainName', url.charAt(url.length - 1) === '/' ? url : url + '/')
    //   //     }
    //   //     if (sessionStorage.getItem('allImgDomainName')) {
    //   //       setTimeout(() => {
    //   //         this.showPage = true
    //   //         this.loadingToast && this.loadingToast.clear()
    //   //       }, 100)
    //   //       resolve(true)
    //   //     } else {
    //   //       this.loadingToast && this.loadingToast.clear()
    //   //       // setTimeout(() => {
    //   //       //   this.$toast.fail('加载失败，请重新刷新')
    //   //       // }, 100)
    //   //       resolve(false)
    //   //     }
    //   //   }).catch(error => {
    //   //     this.loadingToast && this.loadingToast.clear()
    //   //     // setTimeout(() => {
    //   //     //   this.$toast.fail('加载失败')
    //   //     // }, 100)
    //   //     resolve(false)
    //   //     return Promise.reject(error)
    //   //   })
    //   // })
    // },
    // // 获取全局公钥
    // _getKeys () {
    //   // 为免频繁访问获取公私钥接口，缓存public key    edit by 刘桂平 20190610
    //   let wsmallPublickeyData = sessionStorage.getItem('wsmall_publickey_data')
    //   if (!wsmallPublickeyData) {
    //     api.getKeys().then(res => {
    //       if (res.success) {
    //         sessionStorage.setItem('wsmall_publickey_data', JSON.stringify(res.data))
    //       }
    //     })
    //   }
    // },
    // // 查询地区
    // _queryProvince () {
    //   api.queryProvince().then(res => {
    //     if (res.success) {
    //       if (!res.data.current) {
    //         res.data.current = res.data.data.find(v => v.name.indexOf(window.bmapLocation) > -1)
    //       }

    //       this.setAllRegion(res.data.data.slice(0, res.data.data.length - 1)) // 保存所有地区

    //       if (getCookie('selectedRegion')) {
    //         res.data.current = JSON.parse(getCookie('selectedRegion'))
    //       } else {
    //         if (!res.data.current) {
    //           res.data.current = res.data.data[0]
    //         }
    //       }

    //       this.setCurrentRegion(res.data.current || res.data.data[0]) // 保存默认选择渠道
    //       this.setRegion({ data: res.data })

    //       sessionStorage.setItem('region', JSON.stringify(res.data))

    //       if (sessionStorage.getItem('token') && performance.navigation.type !== 0) { // 如果登录且不为司机，且不是打开新窗口（即加载）
    //         if (sessionStorage.getItem('isDriver') === '1') { // 如果是司机
    //           // this._queryCustomerList()
    //         } else {
    //           // this._queryCustomerList().then(() => { // 获取客户列表
    //           //   // this._queryCustomer() // 获取门店列表
    //           // })
    //         }
    //       }
    //     }
    //   })
    // },
    // // 根据地区查询渠道信息
    // _queryCustomer () {
    //   // api.customerAuthQuery({ customerId: this.customer && this.customer.current && this.customer.current.customerId }).then(res => {
    //   //   if (res.success && res.status !== 'noData') {
    //   //     this.setAllChannel(res.data.list.slice(0, res.data.list.length)) // 保存所有渠道/销售部信息

    //   //     this.setChannel({ data: res.data.list })

    //   //     var validRegion = this.region.data ? this.region.data.filter(item => {
    //   //       let obj
    //   //       this.channel.list.forEach(i => {
    //   //         if (item.name.indexOf(i.channelAreaName.split('_')[0]) > -1) {
    //   //           obj = item
    //   //         }
    //   //       })
    //   //       return obj
    //   //     }) : []

    //   //     var current = JSON.parse(getCookie('selectedRegion'))
    //   //     current = validRegion.find(v => current.number === v.number) ? current : validRegion[0]

    //   //     // 根据渠道筛选地区
    //   //     this.setRegion({
    //   //       data: {
    //   //         current,
    //   //         data: validRegion
    //   //       }
    //   //     })

    //   //     // let areaName = this.region && this.region.current && this.region.current.name
    //   //     // let list = this.channel.list.filter(v => {
    //   //     //   return areaName.indexOf(v.channelAreaName.split('_')[0]) > -1
    //   //     // })
    //   //     // this.setChannel({ data: list.length ? list : this.channel.list })
    //   //   } else {
    //   //     this.setChannel({ data: [] })
    //   //   }
    //   // })
    // },
    // // 获取当前用户的客户列表
    // // _queryCustomerList () {
    // //   return api.commonCall({}, 'getCustomerList').then(res => {
    // //     if (res.success) {
    // //       if (res.data && res.data.list && res.data.list.length) {
    // //         this.setCustomer({ data: res.data.list })
    // //       } else {
    // //         this.setCustomer({ data: [] })
    // //       }
    // //     } else {
    // //       this.setCustomer({ data: [] })
    // //     }
    // //   })
    // // },
    // // 登录增加会员积分
    // addMemberIntegral () {
    //   api.commonCall({ behavior: 'B' }, 'saveMemberScore').then(res => {})
    // },

    // 获取不同环境的数据中心不一样的Accountid 
    // getAllDatacenters () {
    //   api.getAllDatacenters().then((res) => {
    //     const def = res.find((item) => item.default)
    //     localStorage.setItem('datacenter', JSON.stringify(def))
    //   })
    // }
  }
}
</script>

<style lang="less">
  html,
  body {
    width: 100%;
    height: 100%;
  }

  /* 隐藏vConsole */
  #__vconsole {
    display: none;
  }

  #app {
    /*width: 100%;*/
    /*height: 100%;*/
    /*-webkit-overflow-scrolling: touch;*/
    /*overflow-y: auto;*/
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* IOS微信阻止字体大小调整 */
    text-size-adjust: 100% !important;
    -webkit-text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
    -webkit-appearance: none;
    background-color: #fff;
    color: #2e3033;
    font-size: 14px;
    /*&:after {*/
    /*//解决 -webkit-overflow-scrolling:touch在有些时候无法滚动的问题*/
    /*min-height: calc(100% + 1px)*/
    /*}*/
    .slide-enter-active,
    .slide-leave-active {
      transition: all 0.2s;
    }
    .slide-enter,
    .slide-leave-to {
      opacity: 0;
      transform: translate3d(100%, 0, 0);
    }
  }

  // ::-webkit-scrollbar {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }

  .van-list {
    &::before, &::after {
      display: block;
      content: ' ';
      height: 0;
      overflow: hidden;
      clear: both;
    }
  }

  .van-nav-bar .van-icon {
    color: #2e3033 !important;
    // font-weight: bold;
    font-size: 40px;
  }

  .van-nav-bar {
    .van-nav-bar__title {
      color: #1B1D21;
      font-weight: 550;
    }
    .van-nav-bar__left .van-nav-bar__arrow{
        height: 55px;
        &::before {
          font-size: 20px;
        }
    }
  }

  .van-tabs .van-tabs__line {
    height: 4px;
  }

  .van-dialog {
    border-radius: 8px;
    .van-dialog__message {
      color: var(--text-text-5, #1B1D21);
      text-align: center;
      font-family: PingFang SC;
      font-size: 18px;
      font-style: normal;
      font-weight: 550;
      line-height: 28px; /* 155.556% */
    }
    .van-dialog__confirm {
      color: #2663FF;
      font-size: 18px;
      font-style: normal;
      font-weight: 550;
    }
    .van-dialog__footer {
      border-top: 1px solid #D3D5DA;
    }
  }

  .van-overlay {
    background-color: rgba(0, 0, 0, .3) !important;
  }
  /** Toast 轻提示 */
  .van-toast {
    padding: 24px 32px !important;
    font-size: 14px !important;
    //line-height: 44px !important;
  }
  .van-toast__text {
    text-align: center;
    word-wrap: break-word;
    word-break: break-all;
  }
  .van-toast--success, .van-toast--fail {
    width: fit-content !important;
    //min-width: 176px;
  }

  .van-image-preview__overlay {
    background-color: rgba(0, 0, 0, 1) !important;
  }

  .van-uploader__wrapper {
    width: 100%;
    height: 100%;
    .van-uploader__input-wrapper {
      width: 100%;
      height: 100%;
    }
  }

  .van-rate__icon {
    font-size: 26px !important;
  }

  .van-button__loading {
    .van-loading__spinner {
      width: 32px !important;
      height: 32px !important;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .slideUp-enter-active,
  .slideUp-leave-active {
    transition: transform 0.3s;
  }

  .slideUp-enter,
  .slideUp-leave-to {
    transform: translate3d(0, 100%, 0);
  }

  .slideDown-enter-active,
  .slideDown-leave-active {
    transition: transform 0.3s;
  }

  .slideDown-enter,
  .slideDown-leave-to {
    transform: translate3d(0, -100%, 0);
  }

  .slideLeft-enter-active,
  .slideLeft-leave-active {
    transition: transform 0.3s;
  }

  .slideLeft-enter,
  .slideLeft-leave-to {
    transform: translate3d(100%, 0, 0);
  }

  .van-button--primary {
    background-color: #2663FF !important;
  }
</style>
